import React from 'react';
import { Maintenance, MaintenanceStatus } from '@/types/common';

interface StatusNotificationProps {
  maintenance: Maintenance;
}

const StatusNotification: React.FC<StatusNotificationProps> = ({
  maintenance,
}) => {
  const getMessage = () => {
    switch (maintenance.status) {
      case MaintenanceStatus.PENDING_APPROVAL_COMPLETION:
        return 'Case is pending approval before it can be closed.';
      case MaintenanceStatus.PENDING_APPROVAL_TEMP_SWAP:
        return 'Approval needed for Temporary swap vehicle. Stakeholder have been notified to provide and must review this case.';
      case MaintenanceStatus.PENDING_APPROVAL_PERM_SWAP:
        return 'Approval needed for Permanent swap vehicle. Stakeholder have been notified to provide and must review this case.';
      default:
        return null;
    }
  };

  const message = getMessage();
  if (!message) return null;

  return (
    <div className="rounded-xl border border-purple-100 bg-[#EFEAF7] px-4 py-3">
      <div className="flex items-start gap-3">
        <span className="mt-0.5 inline-flex h-6 w-6 items-center justify-center rounded-full bg-purple-100 text-purple-600">
          <svg
            className="h-4 w-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </span>
        <div>
          <p className="text-sm font-semibold">Awaiting Approval</p>
          <p className="text-xs">{message}</p>
        </div>
      </div>
    </div>
  );
};

export default StatusNotification;
